import { Button } from '@iwoca/orion';
import { TApplication } from 'lendingApi/applications.types';
import { Link } from 'react-router-dom';
import styles from './ApplicationStatusCell.module.css';

type TProps = {
  disabled: boolean;
  disabledLabel: string;
  status: TApplication['status'];
  buttonText: string;
  variant: 'action' | 'denim' | 'success';
  redirectUrl: string;
  onClick: (e: React.MouseEvent, status: TApplication['status']) => void;
};

export const StatusButtonOrLabel = ({
  disabled,
  disabledLabel,
  status,
  buttonText,
  variant,
  redirectUrl,
  onClick,
}: TProps) => {
  if (disabled) {
    return <span className={styles.noPermissionStatus}>{disabledLabel}</span>;
  }

  return (
    <Link to={redirectUrl}>
      <Button
        variant={variant}
        size="small"
        onClick={(e: React.MouseEvent) => onClick(e, status)}
      >
        {buttonText}
      </Button>
    </Link>
  );
};
